import styles from "./styles.module.css";
import CustomSelect from "../CustomSelect";
import { ClipLoader } from "react-spinners";

const HeaderDropDown = ({
  name,
  id,
  value,
  disabled,
  loaded,
  onChange,
  options,
  hideSideBar,
}) => {
  return (
    <div className={styles["select-container"]}>
      <CustomSelect
        options={options?.map((item) => ({ value: item, label: item }))}
        value={value}
        name={name}
        className="header-form-select"
        onChange={(option) => {
          // normalize to native select onChange event
          if (onChange)
            onChange({
              target: { name: name, value: option ? option.value : "" },
            });
        }}
        placeHolder={options?.[0] ?? ""}
        disabled={disabled}
      />
      {!hideSideBar && !loaded && (
        <div className={styles["selector-loading"]}>
          <ClipLoader size={20} color={"var(--theme-accent)"} />
        </div>
      )}
    </div>
  );
};

export default HeaderDropDown;
